// @flow strict

export const largeGutterSize = 12;
export const smallGutterSize = 8;
